// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__v_AnX","tab":"Tabs_tab__3jbqt","tabActive":"Tabs_tabActive__2p6jc"};